import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';

const About = () => {
  const team = [
    {
      name: "Jesper Olesen",
      title: "Partner, Hd (r)",
      email: "jesper@finansoptimering.dk",
      phone: "51 96 90 64",
      image: "https://assets.auxodev.dk/assets/3ae65674-a84a-41bf-9a95-918b20317861/12133a63-cd8c-4386-9347-e890162f20a5.jpg",
      bio: [
        "Jesper Olesen har arbejdet i finanssektoren i 37 år, heraf 21 år i bankverdenen. De sidste 16 år har Jesper været uvildig rådgiver.",
        "Jesper yder dybdegående rådgivning to både privatpersoner og virksomheder. Fokusområdet har de seneste år været formuepleje, investeringsrådgivning, pensionsrådgivning samt virksomhedsøkonomi, herunder rådgivning omkring virksomhedens finansiering, optimering af den løbende drift samt bankforretninger. I flere virksomheder er Jesper den uformelle sparringspartner for virksomheden og ejer(ne) og Advisory Board-medlem.",
        "Jesper rådgiver indenfor alle aspekter af bankforretninger og udnytter her sin meget store viden omkring banksektoren og den finansielle sektor og deres prissætningspolitik.",
        "Jesper gør sit ypperste for at skræddersy individuelle løsninger til familien, herunder seniorplan (planlægning af pensionsalderen), lånerådgivning (hvilke typer lån skal vi vælge, og hvordan passer det i forhold til vores økonomi m.m.), skat og optimering af bankøkonomi.",
        "Jesper har HD i regnskab, er certificeret som investeringsrådgiver, har lederuddannelse og har deltaget i en lang række af skattekurser og regnskabskurser.",
        "Ordsproget som Jesper sætter stor pris på er: ikke mindre end den optimale løsning er godt nok."
      ]
    },
    {
      name: "Niels Rødsgaard",
      title: "Finansiel rådgiver",
      email: "niels@finansoptimering.dk",
      phone: "50 88 22 22",
      image: "https://assets.auxodev.dk/assets/3ae65674-a84a-41bf-9a95-918b20317861/9ae05c2b-4734-41f5-99d2-5de516b55dcb.jpg",
      bio: [
        "Niels Rødsgaard har 46 års erfaring i den finansielle sektor og har kendskab til finansmarkedet.",
        "Niels er uddannet hos Danske Bank, hvor han i 30 år har arbejdet med alle typer forretninger/produkter til både privat- og erhvervskunder.",
        "Herudover har Niels været ansat i Nordea Bank, Salling Bank, Hvidbjerg Bank med flere og har dermed stor indsigt i forskelligheder i såvel store som mindre pengeinstitutter.",
        "Niels har undervist inden for mange forskellige områder, og dette har været på handelsskolen, i banken og for foreninger.",
        "Dirigenterhverv i såvel større som mindre foreninger.",
        "Niels sætter pris på den ligeværdige dialog og er god til at se på vilkår og betingelser i enhver økonomisk henseende.",
        "Det drejer sig om at optimere!",
        "”Rigtig pris til rigtig kunde” er for Niels en væsentlig faktor.",
        "Klar til at gå i banken? Er du i tvivl? – spørg Niels",
        "Husk – ”jeg ser det med dine øjne” – Vi sidder på samme side af bordet!!!!!!",
        "Niels rådgiver om pension, finansiering, formuepleje og virksomhedsøkonomi."
      ]
    }
  ];

  return (
    <div className="py-16 bg-white">
      <Helmet>
        <title>Om os: Uvildig økonomisk rådgivning | Finansoptimering</title>
        <meta name="description" content="Vi tilbyder uvildig økonomisk rådgivning både til privat og erhverv. Lad os booke et gratis og uforpligtende møde hvor vi gennemgår din økonomi. Se mere her" />
      </Helmet>

      <div className="container mx-auto px-4 max-w-5xl">
        <nav className="text-sm text-slate-500 mb-8 flex items-center space-x-2">
          <Link to="/" className="hover:text-[#b60f00]">Forsiden</Link>
          <span>/</span>
          <span className="text-slate-900 font-medium">Om os</span>
        </nav>

        <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-6 break-words">Om os</h1>
        <p className="text-xl text-slate-600 mb-16">
          Hos Finansoptimering er vi veluddannede rådgivere. Læs lidt om os og vores erfaring her.
        </p>

        <hr className="border-slate-200 mb-16" />

        <div className="space-y-24">
          {team.map((member, index) => (
            <div 
              key={index} 
              className={`flex flex-col ${index % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-12 items-start relative`}
            >
              {index > 0 && <div className="absolute -top-12 left-0 right-0 border-t border-slate-100" />}
              <div className="md:w-1/3 w-full">
                <div className="relative">
                  <div className="absolute -inset-4 bg-red-50 rounded-3xl -z-10"></div>
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    className="rounded-2xl shadow-xl w-full object-cover aspect-[4/5] min-[992px]:h-[300px] min-[992px]:aspect-auto"
                  />
                  <div className="mt-6 space-y-3">
                    <h2 className="text-2xl font-bold text-slate-900">{member.name}</h2>
                    <p className="text-[#b60f00] font-semibold">{member.title}</p>
                    <div className="pt-4 space-y-2">
                      <a href={`mailto:${member.email}`} className="flex items-center text-slate-600 hover:text-[#b60f00] transition-colors text-sm">
                        <Mail size={16} className="mr-3 text-[#b60f00]" />
                        {member.email}
                      </a>
                      <a href={`tel:${member.phone.replace(/\s/g, '')}`} className="flex items-center text-slate-600 hover:text-[#b60f00] transition-colors text-sm">
                        <Phone size={16} className="mr-3 text-[#b60f00]" />
                        Direkte tlf.: {member.phone}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="md:w-2/3 w-full">
                <div className="prose prose-slate prose-lg max-w-none">
                  {member.bio.map((para, i) => {
                    if (para.startsWith("Ordsproget som Jesper sætter stor pris på er:")) {
                      const prefix = "Ordsproget som Jesper sætter stor pris på er: ";
                      const suffix = para.substring(prefix.length);
                      return (
                        <p key={i} className="leading-relaxed text-slate-700">
                          {prefix}
                          <strong className="text-black font-black" style={{ color: '#000000', fontWeight: '900' }}>
                            {suffix}
                          </strong>
                        </p>
                      );
                    }

                    const isHighlighted = para.includes("Rigtig pris") || para.includes("jeg ser det");
                    return (
                      <p 
                        key={i} 
                        className={`leading-relaxed ${isHighlighted ? '!text-black !font-black font-extrabold' : 'text-slate-700'}`}
                        style={isHighlighted ? { color: '#000000', fontWeight: '900' } : undefined}
                      >
                        {para}
                      </p>
                    );
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-24 p-5 md:p-12 bg-slate-900 rounded-3xl text-center text-white shadow-2xl">
          <h2 className="text-3xl font-bold mb-6">Klar til at optimere din økonomi?</h2>
          <p className="text-slate-300 mb-10 text-lg max-w-2xl mx-auto">
            Vi sidder på samme side af bordet og ser din økonomi med dine øjne. Book et uforpligtende møde i dag.
          </p>
          <Link 
            to="/kontakt-os" 
            className="inline-flex items-center bg-[#b60f00] text-white px-10 py-4 rounded-xl font-bold hover:bg-[#a00d00] transition-all shadow-lg active:scale-95"
          >
            Kontakt os nu
          </Link>
        </div>
      </div>
    </div>
  );
};

export default About;
